document.addEventListener('DOMContentLoaded', () => {
  const planCheckbox = document.getElementById('pay_in_installments');
  if (planCheckbox) {
    planCheckbox.addEventListener('click', function() {
      if (this.checked) {
        document.getElementById('div-select-plan').classList.remove('d-none');

        Array.from(document.querySelectorAll('.payment-methods')).forEach((el) => { el.classList.add('d-none'); });
        document.querySelector('.payment-methods[data-payment-method="ideal"]').classList.remove('d-none');
        document.querySelector('#payment_method_ideal').checked = true;
      } else {
        Array.from(document.querySelectorAll('.payment-methods')).forEach((el) => { el.classList.remove('d-none'); });
        document.querySelectorAll('.plan-info').forEach((el) => {
          el.classList.add('d-none');
        });

        document.getElementById('btn-base_plan_id').innerHTML = 'Select a plan <i class="uil uil-angle-down"></i>';
        document.getElementById('base_plan_id').value = '';
        document.getElementById('div-select-plan').classList.add('d-none');
      }
    });
  }
});
